import { imgUrl } from "../../utils/helper";
export const navigationData = [
  {
    name: "Services",
    route: "services",
  },
  {
    name: "Portfolio",
    route: "portfolio",
  },
  {
    name: "About",
    route: "about",
  },
  {
    name: "Contact",
    route: "contact",
  },
];

export const heroData = {
  title: "Make your Digital presence matter",
  subbtitle:
    "We are a full service technology and digital solutions company with over 20 years of experience in industry.",
  btnText: "Start a project together",
  image: imgUrl + "bg2.png",
};
